import React, { useEffect, useState } from 'react'
import "../assets/css/SideBar.css"
import logo from "../assets/images/DarkLogo.png"
import { ReactComponent as Config } from "../assets/images/config.svg"
import { ReactComponent as Arrow } from "../assets/images/arrow.svg"
import { ReactComponent as Home } from "../assets/images/home.svg"
import { ReactComponent as Categories } from "../assets/images/categories.svg"
import { ReactComponent as Voucher } from "../assets/images/voucher.svg"
import { ReactComponent as Mail } from "../assets/images/mail.svg"
import { useNavigate } from 'react-router-dom'

function SideBar({ handleSideBar, activeTab }) {
    const adminArray = JSON.parse(localStorage.getItem("admin"));
    const Role = adminArray?.role
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const navigate = useNavigate()
    const userInfo = JSON.parse(localStorage.getItem("admin"));

    const permissionModule = adminArray?.permission_module || [];

    const menuItems = [
        { text: "Home", route: "/Home", icon: <Home className="config" />, category: "Dashboard" },
        { text: "Users", route: "/users", icon: <Config className="config" />, category: "User Management" },
        { text: "dailyLogingData", route: "/dialyLoginInfo", icon: <Voucher className="config" />, category: "Analytics" },
        { text: "DeviceLoginInfo", route: "/dailyLogingData", icon: <Voucher className="config" />, category: "Analytics" },
        { text: "eventLogs", route: "/eventLogData", icon: <Voucher className="config" />, category: "Analytics" },
        { text: "Upload User CSV", route: "/uploadUserCsv", icon: <Config className="config" />, category: "User Management" },
        { text: "CSV User Day Earnings", route: "/admin/csv-user-day-earnings", icon: <Config className="config" />, category: "User Management", permissionModule: "Upload User CSV" },
        { text: "UserCsvDataStat", route: "/userCsvDataStat", icon: <Config className="config" />, category: "Analytics" },
        { text: "Offer Stats", route: "/offerStats", icon: <Config className="config" />, category: "Analytics" },
        { text: "User Offer Stats", route: "/UserOffer", icon: <Config className="config" />, category: "Analytics" },
        { text: "User Survey Ip Stat", route: "/user/survey/ip/stat", icon: <Config className="config" />, category: "Analytics" },
        // { text: "Profiler Info", route: "/profilerInfo", icon: <Config className="config" />, category: "User Management" },
        { text: "UserPartnerBlocked", route: "/userPartnerBlocked", icon: <Config className="config" />, category: "User Management" },
        { text: "NotificationCampaign", route: "/NotificationCampaign", icon: <Config className="config" />, category: "Notifications" },
        { text: "Announcement", route: "/announcement", icon: <Config className="config" />, category: "Content" },
        { text: "AllCustomBanner", route: "/allcustomBanner", icon: <Voucher className="config" />, category: "Content" },
        { text: "Email Templates", route: "/admin/email-templates", icon: <Mail className="config" />, category: "Notifications" },
        { text: "BannerUserActivity", route: "/bannerUserActivity", icon: <Voucher className="config" />, category: "Content" },
        { text: "Partners", route: "/partners", icon: <Voucher className="config" />, category: "Partners" },
        { text: "PublisherManagement", label: "Publishers", route: "/publishers", icon: <Voucher className="config" />, category: "Partners" },
        { text: "Categories", route: "/categories", icon: <Categories className="config" />, category: "Content" },
        // { text: "AllOffers", route: "/allOffers", icon: <Voucher className="config" />, category: "Offers" },
        { text: "CountryOffers", route: "/countryOffers", icon: <Voucher className="config" />, category: "Offers" },
        { text: "Blogs", route: "/addBlog", icon: <Voucher className="config" />, category: "Content" },
        { text: "All Blogs", route: "/allblogs", icon: <Voucher className="config" />, category: "Content" },
        { text: "Transactions", route: "/transaction", icon: <Voucher className="config" />, category: "Financial" },
        { text: "Gross Data", route: "/grossData", icon: <Voucher className="config" />, role: 3, category: "Financial" },
        { text: "Admins", route: "/admins", icon: <Voucher className="config" />, role: 3, category: "Settings" },
        { text: "UserDeviceInfo", route: "/deviceInfo", icon: <Voucher className="config" />, category: "Analytics" },
        { text: "UserLoginInfo", route: "/loginInfo", icon: <Voucher className="config" />, category: "Analytics" },
        { text: "StaticOfferApi", route: "/staticOffers", icon: <Voucher className="config" />, category: "Offers" },
        { text: "Leaderboard", route: "/leaderboard", icon: <Voucher className="config" />, category: "Gamification" },
        { text: "Pending Earning", route: "/pendingEarning", icon: <Voucher className="config" />, category: "Financial" },
        { text: "PaymentMode", route: "/paymentMode", icon: <Voucher className="config" />, category: "Financial" },
        { text: "AllChallenge", route: "/allchallenge", icon: <Voucher className="config" />, category: "Gamification" },
        { text: "MultiPageData", route: "/allmultiPageData", icon: <Voucher className="config" />, category: "Content" },
        { text: "ReferLinkPage", route: "/referlinkstat", icon: <Voucher className="config" />, category: "Analytics" },
        { text: "ReferThroughStats", route: "/admin/refer-through/stats", icon: <Voucher className="config" />, category: "Analytics" },
        { text: "SpinWheelReward", route: "/spinWheelRewardsData", icon: <Voucher className="config" />, category: "Gamification" },
        { text: "allVideo", route: "/allVideo", icon: <Voucher className="config" />, category: "Content" },
        { text: "StreakData", route: "/streakData", icon: <Voucher className="config" />, category: "Analytics" },
        { text: "Configuration", route: "/configurationInfo", icon: <Voucher className="config" />, category: "Settings" },
        { text: "AllPostBack", route: "/allPostBack", icon: <Voucher className="config" />, category: "Settings" },
        { text: "AppImages", route: "/add/app/images", icon: <Voucher className="config" />, category: "Content" },
        { text: "MetaConfig", route: "/metaconfig", icon: <Voucher className="config" />, category: "Settings" },
         { text: "DeepLinkManagement", route: "/DeepLinkManagement", icon: <Voucher className="config" />, category: "Content" },
         { text: "RatingsManagement", route: "/RatingsManagement", icon: <Voucher className="config" />, category: "Content" },
         { text: "Error Logs", route: "/admin/error-details", icon: <Voucher className="config" />, category: "Content" },
         { text: "PostbackError", route: "/admin/PostbackErrors", icon: <Voucher className="config" />, category: "Content" },
        { text: "Option", route: "/all/option", icon: <Home className="config" />, category: "Survey" },
        { text: "Question", route: "/all/question", icon: <Home className="config" />, category: "Survey" },
        { text: "SurveyParner", route: "/all/survey", icon: <Home className="config" />, category: "Survey" },
        { text: "UserSurveyStatus", route: "/all/survey/user/stats", icon: <Home className="config" />, category: "Survey" },
        { text: "PartnerLeaderboard", route: "/admin/PartnerLeaderboard", icon: <Home className="config" />, category: "Partners" },
        { text: "RegisteredUserSurveyStatus", route: "/register/user/stats", icon: <Home className="config" />, category: "Survey" },
        { text: "Finance", route: "/admin/finance", icon: <Home className="config" />, category: "Invoice" },
        { text: "Revenue", route: "/admin/revenue", icon: <Home className="config" />, category: "Invoice" },
        { text: "invoiceModule", route: "/admin/invoice", icon: <Home className="config" />, category: "Invoice" },
        { text: "userAnalytics", route: "/admin/userAnalytics", icon: <Home className="config" />, category: "Invoice" },
        { text: "partnerAnalytics", label: "Partner Analytics", route: "/admin/partnerAnalytics", icon: <Home className="config" />, category: "Invoice" },
        // { text: "OTP Stats", route: "/admin/otp/stats", icon: <Home className="config" />, category: "Content" },
        { text: "All Rooms", route: "/admin/room-cards", icon: <Voucher className="config" />, category: "LudoAdda" },
        { text: "Create Room", route: "/admin/room-cards/create", icon: <Voucher className="config" />, category: "LudoAdda" },
        { text: "Ludo Analytics", route: "/admin/ludo-analytics", icon: <Voucher className="config" />, category: "LudoAdda" },
        { text: "BulkActivety", route: "/admin/bulk/activity", icon: <Voucher className="config" />, category: "BulkActivety" },
        { text: "UserProfilesStats", route: "/admin/user-profile/stats", icon: <Voucher className="config" />, category: "User Management" },
        // { text: "Matchmaking", route: "/admin/redis/match-making", icon: <Voucher className="config" />, category: "Redis" },
    ];

    const filteredMenuItems = menuItems.filter(item => {
        if (item.role && item.role !== Role) return false;
        const moduleKey = item.permissionModule ?? item.text;
        const hasPermission = Role === 3 || permissionModule.some((k) => k.module === moduleKey);
        const displayName = (item.label || item.text).toLowerCase();
        const matchesSearch =
            displayName.includes(searchQuery.toLowerCase()) ||
            item.text.toLowerCase().includes(searchQuery.toLowerCase());
        return hasPermission && matchesSearch;
    });

    // Group menu items by category
    const groupedMenuItems = filteredMenuItems.reduce((acc, item) => {
        const category = item.category || 'Other';
        if (!acc[category]) {
            acc[category] = [];
        }
        acc[category].push(item);
        return acc;
    }, {});


     useEffect(() => {
        if (window.innerWidth > 600) {
            setIsSidebarOpen(handleSideBar);
        }
    }, [handleSideBar])

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    const handleMenuClick = (route) => {
        navigate(route);
        
        // Close sidebar only in mobile view
        if (window.innerWidth <= 600) {
            setIsSidebarOpen(false); // Direct close instead of toggle
        }
    };



    return (
        <>
            {/* Mobile Overlay */}
            {isSidebarOpen && (
                <div className="sidebar-overlay" onClick={toggleSidebar}></div>
            )}

            {/* Hamburger Menu */}
            <div className='hamburgerParentDiv'>
                <div className='hamburger' onClick={toggleSidebar}>
                    <span className={`hamburger-line ${isSidebarOpen ? 'open' : ''}`}></span>
                    <span className={`hamburger-line ${isSidebarOpen ? 'open' : ''}`}></span>
                    <span className={`hamburger-line ${isSidebarOpen ? 'open' : ''}`}></span>
                </div>
            </div>

            <div className={`sidebar ${isSidebarOpen ? "active" : ''}`}>
                {/* Logo Section */}
                <div className='logoBox'>
                    <img src={logo} alt="logo" />
                </div>

                {/* Search Bar */}
                <div className="searchBox">
                    <svg className="searchIcon" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M21 21L15 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <input 
                        type="text" 
                        placeholder="Search menu..." 
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        className="searchInput"
                    />
                </div>

                {/* Menu Section with Categories */}
                <div className="menuCover">
                    {Object.keys(groupedMenuItems).length > 0 ? (
                        Object.entries(groupedMenuItems).map(([category, items]) => (
                            <div key={category} className="menuCategory">
                                <div className="categoryLabel">{category}</div>
                                {items.map((menu, index) => (
                                    <div
                                        key={index}
                                        className={activeTab === menu.text ? "sideMenu active" : "sideMenu"}
                                      onClick={() => handleMenuClick(menu.route)}
                                    >
                                        <div className="menuIcon">{menu.icon}</div>
                                        <p className="menuName">{menu.label || menu.text}</p>
                                    </div>
                                ))}
                            </div>
                        ))
                    ) : (
                        <div className="noResults">
                            <p>No menu items found</p>
                        </div>
                    )}
                </div>

                {/* Profile Section */}
                <div className='profileBox'>
                    <div className={`sideMenu profile ${activeTab === "profile" ? "active" : ''}`} onClick={() => handleMenuClick('/profile')}>
                        <div className='profileAvatar'>
                            <p className='adminName'>{userInfo?.adminUsername?.charAt(0)?.toUpperCase()}</p>
                        </div>
                        <div className='profileInfo'>
                            <p className='profileUsername'>{userInfo?.adminUsername}</p>
                            <p className='profileRole'>{Role === 3 ? 'Admin' : 'User'}</p>
                        </div>
                        <Arrow className='arrow' />
                    </div>
                </div>
            </div>
        </>
    )
}

export default SideBar